import { Link } from "react-router-dom";
import { useGetCategorieHierachies } from "../../hooks/useProducts";

const CategoryDesktopMain = ({ handleCatClick, activeIndexCat }) => {
  const {
    data = {},
    isError: categoriesIsError,
    // error: categoriesError,
  } = useGetCategorieHierachies();

  let { categories = [] } = data;

  if (categoriesIsError)
    return (
      <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
        <li className="has-submenus-submenu">
          <span
            className={`text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0`}
          >
            Error getting category hierachies
          </span>
        </li>
      </ul>
    );

  return (
    <>
      <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
        {categories.map((category, index) => (
          <li
            onClick={() => handleCatClick(index)}
            className={`has-submenus-submenu ${
              activeIndexCat === index ? "active" : ""
            }`}
            key={category.id}
          >
            <Link
              // onClick={() => setActiveIndexCat(null)}
              to="#"
              className="text-gray-500 text-15 py-8 px-16 flex-align gap-8 rounded-0"
            >
              <span className="text-xs">{category.name}</span>
              <span className="icon text-md d-flex ms-auto">
                <i className="ph ph-caret-right" />
              </span>
            </Link>
            <div
              className={`submenus-submenu py-16 ${
                activeIndexCat === index ? "open" : ""
              }`}
            >
              <h6 className="text-xs px-16 submenus-submenu__title">
                {category.name}
              </h6>
              <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                {category.children.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/products/category?category=${cat.name}&categoryId=${cat.id}`}
                      className="text-xs"
                    >
                      {cat?.name}
                    </Link>
                  </li>
                ))}

                {/* <li>
                  <Link to="/shop">Cucumber &amp; Capsicum</Link>
                </li>
                <li>
                  <Link to="/shop">Leafy Vegetables</Link>
                </li>
                <li>
                  <Link to="/shop">Root Vegetables</Link>
                </li>
                <li>
                  <Link to="/shop">Beans &amp; Okra</Link>
                </li>
                <li>
                  <Link to="/shop">Cabbage &amp; Cauliflower</Link>
                </li>
                <li>
                  <Link to="/shop">Gourd &amp; Drumstick</Link>
                </li>
                <li>
                  <Link to="/shop">Specialty</Link>
                </li> */}
              </ul>
            </div>
          </li>
        ))}

        {/* <li
          onClick={() => handleCatClick(1)}
          className={`has-submenus-submenu ${
            activeIndexCat === 1 ? "active" : ""
          }`}
        >
          <Link
            to="#"
            className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
          >
            <span className="text-xl d-flex">
              <i className="ph ph-brandy" />
            </span>
            <span>Beverages</span>
            <span className="icon text-md d-flex ms-auto">
              <i className="ph ph-caret-right" />
            </span>
          </Link>
          <div
            className={`submenus-submenu py-16 ${
              activeIndexCat === 1 ? "open" : ""
            }`}
          >
            <h6 className="text-lg px-16 submenus-submenu__title">Beverages</h6>
            <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
              <li>
                <Link to="/shop">Soda &amp; Cocktail Mix </Link>
              </li>
              <li>
                <Link to="/shop"> Sports &amp; Energy Drinks</Link>
              </li>
              <li>
                <Link to="/shop"> Non Alcoholic Drinks</Link>
              </li>
              <li>
                <Link to="/shop"> Packaged Water </Link>
              </li>
              <li>
                <Link to="/shop"> Spring Water</Link>
              </li>
              <li>
                <Link to="/shop"> Flavoured Water </Link>
              </li>
            </ul>
          </div>
        </li>
        <li
          onClick={() => handleCatClick(2)}
          className={`has-submenus-submenu ${
            activeIndexCat === 2 ? "active" : ""
          }`}
        >
          <Link
            to="#"
            className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
          >
            <span className="text-xl d-flex">
              <i className="ph ph-brandy" />
            </span>
            <span>Meats &amp; Seafood</span>
            <span className="icon text-md d-flex ms-auto">
              <i className="ph ph-caret-right" />
            </span>
          </Link>
          <div
            className={`submenus-submenu py-16 ${
              activeIndexCat === 2 ? "open" : ""
            }`}
          >
            <h6 className="text-lg px-16 submenus-submenu__title">
              Meats &amp; Seafood
            </h6>
            <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
              <li>
                <Link to="/shop"> Fresh Meat </Link>
              </li>
              <li>
                <Link to="/shop"> Frozen Meat</Link>
              </li>
              <li>
                <Link to="/shop"> Marinated Meat</Link>
              </li>
              <li>
                <Link to="/shop"> Fresh &amp; Frozen Meat</Link>
              </li>
            </ul>
          </div>
        </li>
        <li
          onClick={() => handleCatClick(3)}
          className={`has-submenus-submenu ${
            activeIndexCat === 3 ? "active" : ""
          }`}
        >
          <Link
            to="#"
            className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
          >
            <span className="text-xl d-flex">
              <i className="ph ph-brandy" />
            </span>
            <span>Breakfast &amp; Dairy</span>
            <span className="icon text-md d-flex ms-auto">
              <i className="ph ph-caret-right" />
            </span>
          </Link>
          <div
            className={`submenus-submenu py-16 ${
              activeIndexCat === 3 ? "open" : ""
            }`}
          >
            <h6 className="text-lg px-16 submenus-submenu__title">
              Breakfast &amp; Dairy
            </h6>
            <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
              <li>
                <Link to="/shop"> Oats &amp; Porridge</Link>
              </li>
              <li>
                <Link to="/shop"> Kids Cereal</Link>
              </li>
              <li>
                <Link to="/shop"> Muesli</Link>
              </li>
              <li>
                <Link to="/shop"> Flakes</Link>
              </li>
              <li>
                <Link to="/shop"> Granola &amp; Cereal Bars</Link>
              </li>
              <li>
                <Link to="/shop"> Instant Noodles</Link>
              </li>
            </ul>
          </div>
        </li>
        <li
          onClick={() => handleCatClick(4)}
          className={`has-submenus-submenu ${
            activeIndexCat === 4 ? "active" : ""
          }`}
        >
          <Link
            to="#"
            className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
          >
            <span className="text-xl d-flex">
              <i className="ph ph-brandy" />
            </span>
            <span>Frozen Foods</span>
            <span className="icon text-md d-flex ms-auto">
              <i className="ph ph-caret-right" />
            </span>
          </Link>
          <div
            className={`submenus-submenu py-16 ${
              activeIndexCat === 4 ? "open" : ""
            }`}
          >
            <h6 className="text-lg px-16 submenus-submenu__title">
              Frozen Foods
            </h6>
            <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
              <li>
                <Link to="/shop"> Instant Noodles </Link>
              </li>
              <li>
                <Link to="/shop"> Hakka Noodles</Link>
              </li>
              <li>
                <Link to="/shop"> Cup Noodles</Link>
              </li>
              <li>
                <Link to="/shop"> Vermicelli</Link>
              </li>
              <li>
                <Link to="/shop"> Instant Pasta</Link>
              </li>
            </ul>
          </div>
        </li>
        <li
          onClick={() => handleCatClick(5)}
          className={`has-submenus-submenu ${
            activeIndexCat === 5 ? "active" : ""
          }`}
        >
          <Link
            to="#"
            className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
          >
            <span className="text-xl d-flex">
              <i className="ph ph-brandy" />
            </span>
            <span>Biscuits &amp; Snacks</span>
            <span className="icon text-md d-flex ms-auto">
              <i className="ph ph-caret-right" />
            </span>
          </Link>
          <div
            className={`submenus-submenu py-16 ${
              activeIndexCat === 5 ? "open" : ""
            }`}
          >
            <h6 className="text-lg px-16 submenus-submenu__title">
              Biscuits &amp; Snacks
            </h6>
            <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
              <li>
                <Link to="/shop"> Salted Biscuits </Link>
              </li>
              <li>
                <Link to="/shop"> Marie, Health, Digestive</Link>
              </li>
              <li>
                <Link to="/shop"> Cream Biscuits &amp; Wafers </Link>
              </li>
              <li>
                <Link to="/shop"> Glucose &amp; Milk biscuits</Link>
              </li>
              <li>
                <Link to="/shop"> Cookies</Link>
              </li>
            </ul>
          </div>
        </li>
        <li
          onClick={() => handleCatClick(6)}
          className={`has-submenus-submenu ${
            activeIndexCat === 6 ? "active" : ""
          }`}
        >
          <Link
            to="#"
            className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
          >
            <span className="text-xl d-flex">
              <i className="ph ph-brandy" />
            </span>
            <span>Grocery &amp; Staples</span>
            <span className="icon text-md d-flex ms-auto">
              <i className="ph ph-caret-right" />
            </span>
          </Link>
          <div
            className={`submenus-submenu py-16 ${
              activeIndexCat === 6 ? "open" : ""
            }`}
          >
            <h6 className="text-lg px-16 submenus-submenu__title">
              Grocery &amp; Staples
            </h6>
            <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
              <li>
                <Link to="/shop"> Lemon, Ginger &amp; Garlic </Link>
              </li>
              <li>
                <Link to="/shop"> Indian &amp; Exotic Herbs</Link>
              </li>
              <li>
                <Link to="/shop"> Orangic Vegetables</Link>
              </li>
              <li>
                <Link to="/shop">Orangic Fruits </Link>
              </li>
              <li>
                <Link to="/shop"> Orangic Dry Fruits</Link>
              </li>
              <li>
                <Link to="/shop"> Orangic Dals &amp; pulses</Link>
              </li>
              <li>
                <Link to="/shop"> Orangic Millet &amp; Flours</Link>
              </li>
            </ul>
          </div>
        </li> */}
      </ul>
    </>
  );
};

export default CategoryDesktopMain;
